import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

// Стрелка раскрывающихся списков из дизайн-системы (Icon/Chevron-down в Figma):
// линия 8x4 со скруглёнными концами внутри рамки 16x16. Берёт цвет текста
// (currentColor), поэтому одинаково работает в Select, Autocomplete и меню
const ChevronDownIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M4 6L8 10L12 6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)

export default ChevronDownIcon
